// frontend/src/config/baselineConfig.js
// PRD-63 WP1: hard cutoff for the "Accept All as Initial Baseline" banner.
//
// Banner only renders for assets whose `createdAt` is strictly greater than
// this timestamp. Set to the PRD-63 WP1 deploy date so every pre-existing
// asset on every existing account suppresses the banner — long-standing
// customers should not be prompted to baseline assets they've been managing
// for months. Going forward, every newly-added asset gets the banner.
//
// Hardcoded rather than env-driven on purpose:
//   - Display-only gate; backend doesn't enforce it.
//   - Eliminates a /config round-trip and the failure modes that come with it.
//   - Eliminates frontend/env drift; one source of truth in source control.
//   - If we ever need to change it (extremely unlikely), it's a one-line
//     frontend deploy.

export const BASELINE_BANNER_MIN_ASSET_CREATED_AT = '2026-05-17T00:00:00Z';
